import { TopMenu } from "./parts/topmenu";
import { Search } from "./search/search";
import { ProviderDetailsPage } from "./pages/provider-details";
import { LocationBlockOrPage } from "./pages/location-details";
import { queryAll, query } from "./utils/utils";
import { slider } from "./components/slider";
import { viewAll } from "./components/view-all";
import { ContactUs } from "./components/contact-us";
import * as bootstrap from 'bootstrap';
import { LinksAndButtons } from "./components/links-buttons";
import { DropDownMenus } from "./components/dropdown-menu";
import { AnchorNav } from "./components/anchor-nav";
import { StickyHeroNav } from "./components/sticky-hero-nav";
import { ComplexTabsBlock } from "./components/complex-tabs-block";
import { CardCollection } from "./components/card-collection";
import { Hero } from "./components/hero";
import { SearchPage } from "./pages/search";
import { Overview } from "./components/overview";
import { LocationsSpotlight } from "./components/locations-spotlight";
import { Stats } from "./components/stats";
import { Article } from "./pages/article";
import { ContactBlock } from "./components/contact-block";
import { UtilityLinkBlock } from "./components/utility-link-block";
import { TwoColumnBlock } from "./components/two-column-block";
import { Level2Headline } from "./components/level2-headline";
import { FloatingNav } from "./components/floating-nav";
import { NewsletterArchive } from "./components/newsletter-archive";

window.addEventListener('load', (e) => {
	try{
		slider();

		const dropdownMenus = new DropDownMenus();
		dropdownMenus.init();
		window.addDropDownMenus = dropdownMenus.init;

		viewAll();

		// manage links and arrows
		const linksAndButtons = new LinksAndButtons();
		linksAndButtons.addArrowToLearnMoreLinks();
		linksAndButtons.addArrowLinks();
		window.addArrowLinks = linksAndButtons.addArrowLinks;


		// top menu
		const topMenu = new TopMenu();
		window.topMenu = topMenu;
		const search = new Search();
		const cardCollection = new CardCollection();
		const contactUs = new ContactUs();

		// sticky hero nav //
		const stickyHero = new StickyHeroNav();
		const anchorNav = new AnchorNav();

		// just plain old heros //
		const heros = new Hero();

		// location spotlight
		const locationSpotlight = new LocationsSpotlight();

		// stats!
		const stats = new Stats();

		// const contactBlock = new ContactBlock();
		const utilityLinkBlock = new UtilityLinkBlock();

		// two column block
		if ( query('.two-column-block') !== null ) {
			const twoColumnBlock = new TwoColumnBlock();
		}

		// level 2 headline
		if( queryAll('.level2-headline').length > 0 ) {
			const level2Headline = new Level2Headline();
		}

		// floating side navigation
		if ( query('section.floating-nav-block') !== null ) {
			const floatingNav = new FloatingNav();
		}

		// newsletter archive
		if ( query('.newsletter-archive-block') !== null ) {
			const newsletterArchive = new NewsletterArchive();
		}

		// search page
		if (query('.search-hero') !== null) {
			const searchPage = new SearchPage();
		}

		// provider details
		if (query('body.single-providers') !== null || query('body.single-locations') !== null) {
			const providerDetailsPage = new ProviderDetailsPage();
		}

		if (query('section.complex-tabs-block') !== null ) {
			const complexTabsBlock = new ComplexTabsBlock();
		}

		// locations
		if (query('.bhs-map') !== null) {
			const locationBlockOrPage = new LocationBlockOrPage();
		}

		if (query('.b-overview-cards-block') !== null) {
			const overviewBlock = new Overview();
		}

		if (query('.single-news') !== null || query('.single-services') !== null ) {
			const article = new Article();
		}

		if(query('.team-member-modal') !== null){
			const modals = document.querySelectorAll('.team-member-modal');
			const footer = document.querySelector('footer');
			modals.forEach(function(element) {
				footer.appendChild(element);
			});
		}

		console.log('[BHS Theme] Loaded');
	}catch(e){
		console.error('Error loading [BHS Theme]', e);
	}

	if(query('body > .wp-site-blocks') !== null){
		query('body > .wp-site-blocks').style.visibility = 'visible';
		query('body > .wp-site-blocks').style.opacity = 1;
	}

	requestAnimationFrame(() => {
		window.topMenu?.updateFixedHeaderOffset();
	});

}, false);
